import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App } from 'ionic-angular';
import { BusquedaTesoroProvider } from '@providers/busqueda-tesoro/busqueda-tesoro';
import { AuthProvider } from '@providers/auth/auth';
import { BusquedaTesoroInstruccionesPage } from '@pages';

@IonicPage()
@Component({
  selector: 'page-busqueda-tesoro',
  templateUrl: 'busqueda-tesoro.html',
})
export class BusquedaTesoroPage {

  equipo: any;
  historial: Array<any>;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private busquedaTesoroProvider: BusquedaTesoroProvider,
    private authProvider: AuthProvider,
    private app: App,
  ) {
    this.historial= [];
  }

  async ionViewDidLoad() {
    await this.obtenEquipo();
    await this.historico();
  }

  initRequest(refresher) {
    this.historico();

    if ( refresher ) {
      refresher.complete();
    }
  }

  async obtenEquipo() {
    this.equipo = await this.authProvider.getEquipo();
  }

  async historico() {
    try {
      this.historial = await this.busquedaTesoroProvider.historial(this.equipo.area._id);
      this.verificaNuevoCertamen();
    } catch (e) {
      console.log(e);
    }
  }

  async verificaNuevoCertamen() {
    let busquedaTesoro = this.historial.find( h => h.estatus);

    if(busquedaTesoro) {
      let muestraInstrucciones = await this.busquedaTesoroProvider.muestraInstrucciones();
      if(!muestraInstrucciones) {
        this.app.getRootNavs()[0].setRoot(BusquedaTesoroInstruccionesPage, {
          busquedaTesoro: busquedaTesoro
        });

        this.busquedaTesoroProvider.actualizaMuestraInstrucciones(true);
      }
    } else {
      this.busquedaTesoroProvider.actualizaMuestraInstrucciones(false);
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/busqueda-tesoro/busqueda-tesoro.ts